import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { logoutSSO, MY_HOST } from '../../ts/Common';

interface AuthRedirectLogOutProps {
    setIsLoggedIn: React.Dispatch<React.SetStateAction<boolean>>
    setUser: React.Dispatch<React.SetStateAction<string>>
    setShowLoginError: React.Dispatch<React.SetStateAction<string>>
    setLoginErrorText: React.Dispatch<React.SetStateAction<string>>
}

export default function AuthRedirectLogOut(props: AuthRedirectLogOutProps) {
    const { setIsLoggedIn, setUser, setShowLoginError, setLoginErrorText } = props;
    const navigate = useNavigate();

    useEffect(() => {
        Logout()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const Logout = async function () {
        try {
            let logoutResponse = await logoutSSO(`${MY_HOST}/api/Account/LogOutLinkSSO`)
            if (!logoutResponse.ok) {
                navigate('/login');
                console.log("AuthRedirectLogout: SSO Logout failed")
                return;
            }
            console.log('AuthRedrectLogout: Successful SSO Logout');
            setShowLoginError("none");
            setUser('')
            setIsLoggedIn(false);
            navigate('/login');
        } catch (err) {
            console.log(err);
            setShowLoginError("block");
            setLoginErrorText("Error logging out, please try again");
        }
    }

    return (
        <></>
    );
};